export const GPG_KEYS = 'gpg-keys';
export const METRICS = 'metrics';
export const INTEGRATION_OPTIONS = 'integration-options';
export const DESTINATION_OPTIONS = 'destination-options';
export const DASHBOARD = 'dashboard';
export const DASHBOARD_STATS = 'dashboard-stats';
export const COVERAGE_STATS = 'coverage-stats';
export const COVERAGE_TABLE = 'coverage-table';
export const CRITICAL_ASSETS = 'critical-assets';
export const DEPENDENCIES_DATA = 'dependencies-data';
export const DEPENDENCIES_COUNTERS = 'dependencies-counters';
export const TEST_OVERVIEW = 'test-overview';
export const TEST_DATA = 'test-data';
export const PULL_REQUESTS = 'pull-requests';
export const USERS = 'users';
export const SLACK = 'slack';
export const TEAMS_WEBHOOKS = 'teams-webhooks';
export const TEAMS_DEFAULTS = 'teams-defaults';
export const TEAMS_BOT = 'teams-bot';
export const TEAMS_BOT_DEFAULTS = 'teams-bot-defaults';
export const PAGER_DUTY = 'pager-duty';
export const TICKETING = 'ticketing';
export const SERVICENOW_CONFIG = 'servicenow-config';
export const DATA_CATALOG = 'data-catalog';
export const ATLAN = 'atlan';
export const BI_INTEGRATIONS = 'bi-integrations';
export const OPSGENIE = 'opsgenie';
export const INCIDENT_IO = 'incident-io';
export const ROOTLY = 'rootly';
export const PERSONAL_TOKENS = 'personal-tokens';
export const ACCOUNT_TOKENS = 'account-tokens';
export const RUNTIMES = 'runtimes';
export const RUNTIME_TOKENS = 'runtime-tokens';
export const RUNTIME_WAREHOUSE_CONNECTIONS = 'runtime-warehouse-connections';
export const ACCOUNT_USERS = 'account-users';
export const TESTS_POLLING = 'tests-polling';
export const METADATA_VALUES = 'metadata-values';
export const ENVIRONMENTS = 'environments';
export const ENVIRONMENT = 'environment';
export const ALERT_RULES = 'alert-rules';
export const PRE_DELETE_INFO = 'pre-delete-info';
export const INTEGRATION_RULE_COUNTS = 'integration-rule-counts';
export const DIGEST_RULES = 'digest-rules';
export const CODE_PROJECT = 'code-project';
export const CODE_PROJECTS = 'code-projects';
export const AGENT_SESSIONS = 'agent-sessions';
export const CHAT_INTEGRATIONS = 'chat-integrations';
export const TEST_OVERVIEW_SIDEPANEL_EXECUTION =
  'test-overview-side-panel-execution';
export const TEST_CONFIGURATION = 'test-configuration';
export const TEST_MANAGEMENT_TESTS = 'test-management-tests';
export const NANGO = 'nango';
export const AI_RULES = 'ai-rules';
export const EXTENDED_METADATA_VALUES_OPTIONS =
  'extended-metadata-values-options';
export const TEST_CONDITIONAL_ALERT_DESTINATIONS =
  'test-conditional-alert-destinations';
export const DATA_HEALTH = 'data-health';
export const COVERAGE_TABLE_FILTERS_QUERY = 'coverage-table-filters';
export const TEST_OVERVIEW_SIDEPANEL_EXECUTION_HISTORY =
  'test-overview-side-panel-execution-history';
export const DESTINATIONS = 'destinations';
export const TEST_TEMPLATES = 'test-templates';
export const TEST_TEMPLATE = 'test-template';
export const DIMENSION_VALUES = 'dimension-values';
export const DATA_POINTS = 'data-points';
export const RESOURCES = 'resources';
export const RESOURCES_COLUMNS = 'resources-columns';
export const DATA_HEALTH_TOTAL_FORMULA = 'data-health-total-formula';
export const DATA_HEALTH_QUALITY_DIMENSION_THRESHOLDS =
  'data-health-quality-dimension-thresholds';
export const DWH = 'dwh';
export const ESTIMATIONS = 'estimations';
export const SETTINGS = 'settings';
export const PERMISSIONS = 'permissions';
export const ACCOUNT = 'account';
export const AI_QUOTA = 'ai-quota';
export const AI_USAGE = 'ai-usage';
export const AI_USAGE_PERSONAL = 'ai-usage-personal';
export const AI_BYOK_SETTINGS = 'ai-byok-settings';
export const AI_MCP_DBT_CLOUD = 'ai-mcp-dbt-cloud';
export const INVOCATIONS = 'invocations';
export const MODEL_RUNS_TABLE_ASSETS = 'model-runs-table-assets';
export const MODEL_RUNS_TABLE_ASSETS_FILTER_OPTIONS =
  'model-runs-table-assets-filter-options';
export const MODEL_EXEC_HISTORY = 'model-exec-history';
export const CATALOG_TABLE_ASSETS = 'catalog-table-assets';
export const CATALOG_TABLE_ASSETS_FILTER_OPTIONS =
  'catalog-table-assets-filter-options';
export const ASSET = 'asset';
export const LINEAGE = 'lineage';
export const LINEAGE_ASSET_COLUMNS = 'lineage-asset-columns';
export const LINEAGE_HIGHLIGHT_COLUMNS = 'lineage-highlight-columns';
export const TABLE_ASSETS = 'table-assets';
export const BULK_EDIT_ASSETS = 'bulk-edit-assets';
export const TREE_CATEGORIES = 'tree-categories';
export const SAVED_VIEWS = 'saved-views';
export const TEST_RESULTS = 'test-results-table-data';
export const ACCOUNT_ROLES = 'account-role';
export const ACCOUNT_GROUPS = 'account-groups';
export const JIRA_PROJECT_FIELDS = 'jira-project-fields';
export const JIRA_SITE_URL = 'jira-site-url';
export const JIRA_FIELD_AUTOCOMPLETE = 'jira-field-autocomplete';
export const SSO_CONFIG = 'sso-config';
export const SCIM_CONFIG = 'scim-config';
export const TEST_RESULTS_FILTER_OPTIONS = 'test-results-filter-options';
export const TEST_RESULTS_GROUP_STATUS_SUMMARY =
  'test-results-group-status-summary';
export const TEST_RUNS = 'test-runs-table-data';
export const TEST_RUNS_FILTER_OPTIONS = 'test-runs-filter-options';
export const TEST_RUN_EXECUTION_HISTORY = 'testRunExecutionHistory';
export const INCIDENT_LIST_PAGED = 'incident-list-paged';
export const INCIDENT_LIST_FILTER_OPTIONS = 'incident-list-filter-options';
export const INCIDENT_LIST_GROUP_SUMMARY = 'incident-list-group-summary';
export const INCIDENTS_SETTINGS = 'incidents-settings';
export const TREE_STATUS_TOTALS = 'treeStatusTotals';
export const TREE_INCIDENT_STATUS_TOTALS = 'treeIncidentStatusTotals';
export const INCIDENT_GRAPHQL_DETAIL = 'incident-graphql-detail';
export const INCIDENT_GRAPHQL_LINEAGE = 'incident-graphql-lineage';
export const INCIDENT_TICKETS = 'incident-tickets';
export const INCIDENT_DEFAULT_TICKET_FIELDS = 'incident-default-ticket-fields';
export const INCIDENT_SUMMARY = 'incident-summary';
export const INCIDENT_MERGE_CARDS = 'incident-merge-cards';
export const AGENT_MERGE_INCIDENT_TITLES = 'agent-merge-incident-titles';
export const PIPELINE_RUN = 'pipeline-run';
export const ENVIRONMENT_INTEGRATIONS = 'environment-integrations';
export const ENVIRONMENTS_INTEGRATIONS = 'environments-integrations';
export const TICKET_SEARCH = 'ticket-search';
export const FIVETRAN_CONFIG = 'fivetranConfig';
export const CONNECTION_HEALTH = 'connection-health';

export const ENTITY_QUERY_KEYS = {
  incidents: [
    INCIDENT_LIST_PAGED,
    INCIDENT_LIST_FILTER_OPTIONS,
    INCIDENT_LIST_GROUP_SUMMARY,
    INCIDENT_GRAPHQL_DETAIL,
    INCIDENT_GRAPHQL_LINEAGE,
    INCIDENT_SUMMARY,
    INCIDENT_MERGE_CARDS,
    INCIDENT_TICKETS,
    INCIDENT_DEFAULT_TICKET_FIELDS,
    INCIDENTS_SETTINGS,
    TREE_INCIDENT_STATUS_TOTALS,
  ],
  tests: [
    TEST_MANAGEMENT_TESTS,
    TEST_OVERVIEW,
    TEST_DATA,
    TEST_RESULTS,
    TEST_RUNS,
  ],
  assets: [
    CATALOG_TABLE_ASSETS,
    CATALOG_TABLE_ASSETS_FILTER_OPTIONS,
    ASSET,
    TABLE_ASSETS,
    BULK_EDIT_ASSETS,
    CRITICAL_ASSETS,
  ],
};
